import React from "react";
import {
  Row,
  Image,
  Label,
  RootContainer,
  SubContainer,
  Title,
  TitleWrapper,
  Col,
} from "./SportCard.style";
import { FootballIcon } from "@assets";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setAlert, setPrevRoute } from "@redux/game/gameSlice";
import { useGame } from "@hooks";
import { useLocation } from "react-router-dom";

const SportCard = ({ football_agents }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { launchGame } = useGame();
  const { pathname, search } = useLocation();

  const handleGameClicked = (game) => {
    if (!game.active) {
      dispatch(
        setAlert({
          title: t("maintain.maintainTitle"),
          description: (
            <>
              {t("maintain.maintainSubtitle1")} <br />{" "}
              {t("maintain.maintainSubtitle2")}
            </>
          ),
          open: true,
          maintain: true,
        })
      );
      return;
    }

    /**
     * Save pathname to redux,
     * to use from ingame page for going back
     **/
    dispatch(setPrevRoute(pathname + search));
    /**
     * Launch game
     */
    launchGame(game);
  };

  return (
    <RootContainer>
      <Row gutter={20}>
        {football_agents.map((football_agent, index) => (
          <Col key={index} onClick={() => handleGameClicked(football_agent)}>
            <SubContainer>
              <Image src={football_agent.icon} alt={football_agent.name} />
              <Label>{football_agent.name}</Label>
            </SubContainer>
          </Col>
        ))}
      </Row>
      <TitleWrapper>
        <FootballIcon />
        <Title>{t("home.sportTitle")}</Title>
        <FootballIcon />
      </TitleWrapper>
    </RootContainer>
  );
};

export default SportCard;
